// Ampulheta da espera do shell: pixel art em cima da cabeça de quem está esperando um comando
// (status 'shell'). Fica parada com a areia embaixo, vira (quadro de giro de lado) e fica parada
// com a areia em cima, e volta. Com movimento reduzido, fica sempre no primeiro quadro.
//
// Cores só pela paleta (wood, glass, gold). Luz do alto-esquerda; o contorno é o tom 0 do vidro.

import { sprite } from './pix.js';
import type { PixelSprite } from './types.js';

/** Quanto tempo a ampulheta fica parada em cada posição (ms). */
export const AMPULHETA_PARADA_MS = 2000;
/** Duração do quadro de giro, de lado (ms). */
export const AMPULHETA_GIRO_MS = 180;

const PALETA = { W: 'wood2', w: 'wood0', g: 'glass0', G: 'glass1', h: 'glass3', S: 'gold2', s: 'gold1' };

// Areia embaixo: as linhas 6 a 9 do bulbo de baixo estão cheias.
const EM_PE = [
  'wwwwwww', // 0 tampa (contorno)
  '.WWWWW.', // 1 tampa
  '.ghGGg.', // 2 bulbo de cima (boca)
  '..gGg..', // 3
  '...g...', // 4 gargalo
  '...g...', // 5
  '..gSg..', // 6 bulbo de baixo, areia
  '.gSSSg.', // 7
  'gSSSSSg', // 8
  'gsssssg', // 9 areia escura no fundo
  'wwwwwww', // 10 base (contorno)
];

const DE_CABECA = [...EM_PE].reverse();
const GIRO = EM_PE.map((linha) => linha.slice(2, 5));

/** Quadros: parada em pé, giro, parada de cabeça para baixo, giro. */
export const AMPULHETA_QUADROS: readonly PixelSprite[] = [EM_PE, GIRO, DE_CABECA, GIRO].map((rows) => sprite(rows, PALETA));

/** Altura da ampulheta em px de arte (o campus a põe logo acima da cabeça). */
export const AMPULHETA_ALTURA = EM_PE.length;

/**
 * Quadro da ampulheta no instante `now` (ms). Ciclo: parada, giro, parada, giro. Com movimento
 * reduzido, sempre o primeiro (em pé).
 */
export function ampulhetaQuadro(now: number, reduzido = false): number {
  if (reduzido) return 0;
  const ciclo = 2 * (AMPULHETA_PARADA_MS + AMPULHETA_GIRO_MS);
  const t = now % ciclo;
  if (t < AMPULHETA_PARADA_MS) return 0;
  if (t < AMPULHETA_PARADA_MS + AMPULHETA_GIRO_MS) return 1;
  if (t < 2 * AMPULHETA_PARADA_MS + AMPULHETA_GIRO_MS) return 2;
  return 3;
}
